import { type AbstractControl, type ValidationErrors } from '@angular/forms';
import type { IPhoneInfoFormValue } from '../models/phone-info-form-value.interface';

export function phoneInfoRequiredValidator(control: AbstractControl<IPhoneInfoFormValue>): ValidationErrors | null {
    return control.value?.phone ? null : { required: true };
}
